import moment from "moment";

import { displayDateTime } from "./dateDisplay";
export const formatUploadedAt = (createdAt) => {
  if (!createdAt) {
    return "—";
  }

  return displayDateTime(createdAt);
};

export const formatRetentionExpiresAt = (retentionExpiresAt) => {
  if (!retentionExpiresAt) {
    return "—";
  }

  return moment(retentionExpiresAt).format("DD/MM/YYYY");
};

export const filterSecureFiles = (files, searchQuery, getShareStatus) => {
  const query = searchQuery.trim().toLowerCase();
  if (!query) {
    return files;
  }

  return files.filter((file) => {
    const status = getShareStatus(file);
    const searchableText = [
      file.fileName,
      file.uploadedByName,
      status.label,
      status.linkDetail,
      formatUploadedAt(file.createdAt),
      formatRetentionExpiresAt(file.retentionExpiresAt),
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();

    return searchableText.includes(query);
  });
};

export const SECURE_FILE_SORT_COLUMNS = {
  FILE_NAME: "fileName",
  UPLOADED_BY: "uploadedByName",
  UPLOADED_AT: "createdAt",
};

export const DEFAULT_SECURE_FILE_SORT = {
  column: SECURE_FILE_SORT_COLUMNS.UPLOADED_AT,
  direction: "desc",
};

export const toggleSecureFileSort = (currentSort, column) => {
  if (currentSort.column === column) {
    return {
      column,
      direction: currentSort.direction === "asc" ? "desc" : "asc",
    };
  }

  return { column, direction: "asc" };
};

export const sortSecureFiles = (files, sortConfig) => {
  const { column, direction } = sortConfig;
  const multiplier = direction === "desc" ? -1 : 1;

  return [...files].sort((left, right) => {
    if (column === SECURE_FILE_SORT_COLUMNS.UPLOADED_AT) {
      return multiplier * (moment(left.createdAt).valueOf() - moment(right.createdAt).valueOf());
    }

    const leftValue = String(left[column] || "").toLowerCase();
    const rightValue = String(right[column] || "").toLowerCase();

    if (leftValue < rightValue) {
      return -1 * multiplier;
    }
    if (leftValue > rightValue) {
      return 1 * multiplier;
    }
    return 0;
  });
};
